import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/lib/api/queryKeys';
import { notificationRepository } from '../repository';
import { useAuthStore } from '@/store/authStore';
import { ROLES } from '@/lib/config/constants';
import type { ID } from '@/types/common';

export function useNotifications() {
  const canView = useAuthStore((s) => s.isAuthenticated && s.user?.role !== ROLES.SALES);
  return useQuery({
    queryKey: queryKeys.notifications.list(),
    queryFn: () => notificationRepository.list(),
    enabled: canView,
    refetchInterval: 60_000,
  });
}

export function useMarkNotificationRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: ID) => notificationRepository.markRead(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.notifications.all }),
  });
}

export function useMarkAllNotificationsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => notificationRepository.markAllRead(),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.notifications.all }),
  });
}
